import { useState } from 'react';
import { usePersistedChoice } from '@/shared/hooks';

type OpenChoice = 'true' | 'false';
const OPEN_CHOICES: readonly OpenChoice[] = ['true', 'false'];

export interface PageAgentPanelState {
  /** Names what this browser remembers of the panel: whether it is open, and its width. */
  id: string;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

/**
 * Whether a page's agent panel is open, remembered in this browser per `id`, such as the agent's
 * id. `forceOpen` opens it whatever the person last chose, as after an import creates the taxonomy.
 */
export function usePageAgentPanel(id: string, forceOpen = false): PageAgentPanelState {
  const [stored, setStored] = usePersistedChoice(`page-agent.${id}.open`, OPEN_CHOICES, 'false');
  const [forced, setForced] = useState(forceOpen);
  return {
    id,
    isOpen: forced || stored === 'true',
    setIsOpen: (open) => {
      setForced(false);
      setStored(open ? 'true' : 'false');
    },
  };
}
